/* Rakabot's native Klaviyo forms. Load after Klaviyo.js; no private API key. */
(function (root) {
  'use strict';
  const IDS = Object.freeze({ French: 'Thxu72', English: 'WqptaG' });
  const PRODUCT_MAP = root.RakabotPopupProducts || {};
  const ALL_IDS = new Set([...Object.values(IDS), ...Object.values(PRODUCT_MAP).flatMap(p => Object.values(p.forms))]);
  function productForm(context, path, locale) {
    const id = context && context.productId != null ? String(context.productId) : '';
    const raw = String(path || '').match(/\/products\/([^/]+)/);
    let handle = '';
    try { handle = raw ? decodeURIComponent(raw[1]) : ''; } catch (_) { return null; }
    const isProduct = Boolean(id || handle);
    const item = id ? PRODUCT_MAP[id] : Object.values(PRODUCT_MAP).find(p => p.handle === handle);
    if (isProduct) return item ? item.forms[language(locale)] : null;
    return IDS[language(locale)];
  }
  const KEY = 'rakabot.welcome.v1';
  const COOLDOWN = 30 * 24 * 60 * 60 * 1000;
  let stopPrevious = () => {};

  function language(value) {
    return /^(english|en(?:[-_][a-z]{2})?)$/i.test(String(value || '').trim())
      ? 'English' : 'French';
  }

  function start(options = {}) {
    stopPrevious();
    // Enable only after coupon/SMS checks and native form publication.
    if (options.enabled !== true) return () => {};
    const readLanguage = options.getLanguage || (() => root.siteLanguage ?? document.documentElement.lang);
    const eligible = options.isEligible || (() => false);
    let state = {};
    try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (_) {}
    let stopped = false, requested = false, checking = false;
    const timers = new Set();
    const later = (fn, delay) => { const id = setTimeout(fn, delay); timers.add(id); return id; };
    function suppressed() {
      return state.submitted === true || Date.now() - Number(state.closedAt || 0) < COOLDOWN;
    }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {} }
    function excluded() {
      const path = decodeURI(root.location.pathname).toLowerCase();
      return /\/(?:checkouts?|quotes?|devis|soumissions?)(?:\/|$)/.test(path)
        || /\/(?:pages\/)?[^/]*(?:request-a-quote|demande-de-soumission|demande-de-devis)/.test(path)
        || (options.isExcludedPage ? options.isExcludedPage(path) : false);
    }
    async function show() {
      if (stopped || requested || checking || suppressed() || excluded()) return;
      checking = true;
      try {
        // openForm overrides Klaviyo targeting, so enforce audience rules here.
        if (!(await eligible())) return;
        if (typeof root.klaviyo?.isIdentified !== 'function') return;
        if (await root.klaviyo.isIdentified() !== false) return;
        if (stopped || suppressed() || excluded()) return;
        const context = options.getProduct ? options.getProduct() : root.RakabotPopupContext;
        const id = productForm(context, root.location.pathname, readLanguage());
        if (!id) return;
        requested = true;
        root._klOnsite = root._klOnsite || [];
        root._klOnsite.push(['openForm', id]);
      } catch (_) {
        // Missing integration or blocked tracking should not break the storefront.
      } finally { checking = false; }
    }
    function scroll() {
      const available = document.documentElement.scrollHeight - root.innerHeight;
      if (available > 0 && root.scrollY / available >= 0.4) void show();
    }
    function activity(event) {
      const detail = event.detail || {};
      if (!ALL_IDS.has(detail.formId)) return;
      if (detail.type === 'submit') { state.submitted = true; save(); }
      if (detail.type === 'close') { state.closedAt = Date.now(); save(); }
    }
    root.addEventListener('scroll', scroll, { passive: true });
    root.addEventListener('klaviyoForms', activity);
    later(() => void show(), 6000);
    scroll();
    stopPrevious = () => {
      stopped = true;
      timers.forEach(clearTimeout);
      root.removeEventListener('scroll', scroll);
      root.removeEventListener('klaviyoForms', activity);
    };
    return stopPrevious;
  }
  root.RakabotWelcomePopup = Object.freeze({ start, language, productForm, formIds: IDS });
})(window);
